<template>
    <header>
        <nav class="teal" role="navigation">
            <div class="nav-wrapper">
                <!-- <a data-activates="slide-out" class="button-collapse show-on-" href="#!">Circular de Ofertas</a> -->

                <ul class="right hide-on-med-and-down">
                    <li>
                        <a class='right' href='/logout' data-target='user_dropdown'><i class=' material-icons'>exit_to_app</i></a>
                    </li>
                </ul>

                <a href="#" data-activates="slide-out" class="button-collapse"><i class="mdi-navigation-menu"></i></a>
            </div>
        </nav>

        <nav>
        <div class="nav-wrapper teal darken-2">
            <router-link v-for="bread in breadcrumb" :key="bread.url" :to="bread.url" class="breadcrumb" style="text-decoration: none;">
            {{ bread.title }}
            </router-link>
            <!-- <a class="breadcrumb" href="#!">Index</a> -->

            <div style="margin-right: 20px;" id="timestamp" class="right"></div>
        </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'header-theme',
    props: ["breadcrumb"],
    mounted() {
        $(document).ready(function(){
            $('.collapsible').collapsible();

            $('.dropdown-trigger').dropdown();
        });
    }
}
</script>

<style lang="scss" scoped>
    header {
        padding-left: 300px;
    }
    .breadcrumb:first-child {
        margin-left: 20px;
    }
</style>





// WEBPACK FOOTER //
// src/components/shared/header_theme/HeaderTheme.vue